import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request view.
 * @extends JetView
 */
export default class recordTableWithdrawalRequestView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for detailed view of withdrawal requests
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'windowDetailsWithdrawal',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails', // DataTable ID for details
                css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                select: true,
                columns: [
                    {
                        id: 'detailTittle',
                        header: '',
                        width: 50,
                        height: 25,
                        tooltip: 'Detalles', // Tooltip for details
                        template: function (obj) {
                            return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                        },
                    },
                    { id: 'Id', header: 'ID', width: 80, sort: 'int' }, // Column for ID
                    {
                        id: 'UserModifId',
                        header: _('Modificó'), // Column for user who modified
                        width: 90,
                        sort: 'int',
                    },
                    { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Column for date
                    { id: 'Type', header: _('Tipo'), width: 90, sort: 'int' }, // Column for type
                    {
                        id: 'Amount',
                        header: _('Monto'), // Column for amount
                        format: webix.i18n.priceFormat, // Formatting for price
                        exportType: 'number',
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Description',
                        header: _('Descripción'), // Column for description
                        width: 250,
                        sort: 'int',
                    },
                ],
                onClick: {
                    details: function (euv, id) {
                        var item = this.getItem(id); // Get clicked item
                        vthis.app.callEvent('withdrawTransDetail:select', [item]); // Trigger event with item
                        $$('detailsWithdrawal').show(); // Show details window
                    },
                },
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true,
            scrollY: screen.width < 820 ? false : true, // Conditional scroll based on screen width
            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
            columns: [
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: 'Detalles', // Tooltip for details
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close details'></span>"; // Template for detail icon
                    },
                },
                { id: 'Id', header: 'ID', width: 80, sort: 'int' }, // Column for ID
                {
                    id: 'UserModifId',
                    header: _('Modificó'), // Column for user who modified
                    width: 90,
                    sort: 'int',
                },
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Column for date
                { id: 'Type', header: _('Tipo'), width: 90, sort: 'int' }, // Column for type
                {
                    id: 'Amount',
                    header: _('Monto'), // Column for amount
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number',
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Column for description
                    width: 250,
                    sort: 'int',
                },
            ],
            onClick: {
                details: function (euv, id) {
                    var item = this.getItem(id); // Get clicked item
                    this.$scope.app.callEvent('withdrawTransDetail:select', [item]); // Trigger event with item
                },
            },
            tooltip: true, // Enable tooltips
            pager: 'pagerA', // Pager ID for pagination
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid instance.
     */
    init(grid) {
        var url =
            devConfig.geturlApi() + // API URL for fetching data
            'es/Client/GetClientWithdrawalRequestsDetail';
        this.on(this.app, 'user:id', (idUser) => {
            grid.load(url + '?id=' + idUser); // Load grid data based on user ID
            $$('dtDetails').clearAll(); // Clear previous details
            $$('dtDetails').load(url + '?id=' + idUser); // Load details for the user
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('withdrawTransDetail:select', [item]); // Trigger event with item
        });
    }
}

// FILE DOCUMENTED
